// Helper function to format date properly based on input size
var formatDate = function formatDate(date, format) {
  if (!date) {
    return;
  }

  var month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var month_number = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  var dateObject = new Date(date);
  var day = dateObject.getDate();

  if (day.toString().length < 2 && (format === 'MM/DD/YYYY' || format === 'MM/DD/YY')) {
    day = "0".concat(day);
  }

  var month_index = dateObject.getMonth();
  var shortYear = dateObject.getFullYear().toString().substring(2);
  var longYear = dateObject.getFullYear();
  return format === 'MM/DD/YY' ? '' + month_number[month_index] + '/' + day + '/' + shortYear : format === 'MM/DD/YYYY' ? '' + month_number[month_index] + '/' + day + '/' + longYear : '' + month_names[month_index] + ' ' + day + ', ' + longYear;
};

export default formatDate;